// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_FranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /contratos/franquia/:franquia_id — dados sugeridos e os contratos já enviados (Full). */
import type { Contratos_ContratoRow } from './Contratos_ContratoRow'
import type { Contratos_SugestaoRow } from './Contratos_SugestaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_FranquiaResponseDados {
configurado: boolean
modelo_versao: number
sugestao: Contratos_SugestaoRow
contratos: Contratos_ContratoRow[]
}

export type Contratos_FranquiaResponse = ApiResponse<Contratos_FranquiaResponseDados>;

registerResponseContract('Contratos_FranquiaResponse', {
  configurado:   { type: 'boolean', required: true },
  modelo_versao: { type: 'number',  required: true },
  sugestao: {
    type: 'object',
    required: true,
    fields: {
      franqueado_nome:      { type: 'string',  required: false },
      franqueado_cpf:       { type: 'string',  required: false },
      franqueado_endereco:  { type: 'string',  required: false },
      franqueado_email:     { type: 'string',  required: false },
      unidade_razao_social: { type: 'string',  required: false },
      unidade_cnpj:         { type: 'string',  required: false },
      unidade_endereco:     { type: 'string',  required: false },
      franqueadora_nome:    { type: 'string',  required: false },
      franqueadora_email:   { type: 'string',  required: false },
      testemunha1_nome:     { type: 'string',  required: false },
      testemunha1_email:    { type: 'string',  required: false },
      testemunha2_nome:     { type: 'string',  required: false },
      testemunha2_email:    { type: 'string',  required: false },
    },
  },
  contratos: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: true },
      franquia_id:     { type: 'number',  required: true },
      modelo_versao:   { type: 'number',  required: true },
      minuta_id:       { type: 'number',  required: false },
      situacao:        { type: 'string',  required: true },
      franqueado_nome: { type: 'string',  required: false },
      signatarios: {
        type: 'array',
        required: false,
        items: {
          papel:       { type: 'string',  required: false },
          nome:        { type: 'string',  required: false },
          email:       { type: 'string',  required: false },
          situacao:    { type: 'string',  required: false },
          assinado_em: { type: 'string',  required: false },
        },
      },
      enviado_por:     { type: 'string',  required: false },
      enviado_em:      { type: 'string',  required: true },
      concluido_em:    { type: 'string',  required: false },
      tem_assinado:    { type: 'boolean', required: false },
      tem_certificado: { type: 'boolean', required: false },
    },
  },
})
